import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import OfferteVettureList from '../components/OfferteVettureList';

const GestioneOfferteVetturePage = () => {
  return (
    <div className="p-6">
      {/* Breadcrumb */}
      <nav className="flex mb-6" aria-label="Breadcrumb">
        <ol className="flex space-x-4 items-center">
          <li>
            <div>
              <Link to="/nlt/" className="text-gray-400 hover:text-gray-500">
                <HomeIcon className="flex-shrink-0 h-5 w-5" aria-hidden="true" />
                <span className="sr-only">Home</span>
              </Link>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <ChevronRightIcon
                className="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              <Link
                to="/nlt/veicoli"
                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              >
                Veicoli
              </Link>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <ChevronRightIcon
                className="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              <span className="ml-4 text-sm font-medium text-gray-500">
                Gestione Offerte
              </span>
            </div>
          </li>
        </ol>
      </nav>

      {/* Titolo */}
      <div className="md:flex md:items-center md:justify-between mb-8">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Gestione Offerte Vetture
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Visualizza, crea e modifica le offerte di noleggio per i tuoi veicoli
          </p>
        </div>
      </div>

      {/* Contenuto principale */}
      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <OfferteVettureList />
      </div>
    </div>
  );
};

export default GestioneOfferteVetturePage; 